import {h, Fragment} from "preact"
import { usePagination, useActions } from "@nosto/preact"
import Icon from "./elements/Icon"

function PageLink({ onClick, className, ariaLabel, children }) {
    return (
        <a
            class={`ns-page-link ${className}`}
            href="javascript:void(0)"
            aria-label={ariaLabel}
            onClick={onClick}
        >
            {children}
        </a>
    )
}

export default function Pagination() {
    const { prev, first, pages, last, next } = usePagination({
        width: 5
    })
    const { updateSearch } = useActions()

    function setPageCallback({ from }) {
        return () => {
            updateSearch({ products: { from } })
            scrollTo(0, 0)
        }
    }

    return (
        <ul class="ns-d-flex ns-flex-wrap ns-justify-content-center ns-list-unstyled ns-m-0 ns-p-0 ns-my-2 ns-mx-0">
            {prev && (
                <li>
                    <PageLink onClick={setPageCallback(prev)} className="ns-previous Pagination__NavItem" ariaLabel="Previous">
                        <svg class="Icon Icon--select-arrow-left " role="presentation" viewBox="0 0 11 18">
                            <path d="M9.5 1.5L1.5 9l8 7.5" stroke-width="2" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"></path>
                        </svg>
                    </PageLink>
                </li>
            )}
            {first && (
                <li class="Pagination__NavItem">
                    <PageLink onClick={setPageCallback(first)} ariaLabel="First">
                        {first.page}
                    </PageLink>
                </li>
            )}

            {first && (
                <li class="Pagination__NavItem">
                    <span class="ns-d-block">...</span>
                </li>
            )}

            {pages.map(page => (
                <>
                    <li class={`Pagination__NavItem ${page.current ? "is-active ns-h-100" : ""}`}>
                        <PageLink onClick={setPageCallback(page)}>{page.page}</PageLink>
                    </li>
                </>
            ))}
            {last && (
                <li class="Pagination__NavItem">
                    <span>...</span>
                </li>
            )}
            {last && (
                <li class="Pagination__NavItem">
                    <PageLink onClick={setPageCallback(last)} ariaLabel="Last">{last.page}</PageLink>
                </li>
            )}
            {next && (
                <li>
                    <PageLink onClick={setPageCallback(next)} className="ns-next Pagination__NavItem" ariaLabel="Next">
                        <svg class="Icon Icon--select-arrow-right " role="presentation" viewBox="0 0 11 18">
                            <path d="M1.5 1.5l8 7.5-8 7.5" stroke-width="2" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"></path>
                        </svg>
                    </PageLink>
                </li>
            )}
        </ul>
    )
}
